import { render, staticRenderFns } from "./CreateStaticAssessment.vue?vue&type=template&id=2d03d88e&scoped=true&"
import script from "./CreateStaticAssessment.vue?vue&type=script&lang=js&"
export * from "./CreateStaticAssessment.vue?vue&type=script&lang=js&"
import style0 from "./CreateStaticAssessment.vue?vue&type=style&index=0&id=2d03d88e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d03d88e",
  null
  
)

export default component.exports